<div class="row">
  <div class="col-sm-1"></div>
  <div class="col-sm-10"></div>
  <div class="col-sm-1"></div>
</div>
<section
  style="
    position: relative;
    display: block;
    overflow-x: hidden;
  "
>
  <div
    style="
      width: 100%;
      padding-left: 15px;
      padding-right: 15px;
      margin-left: auto;
      margin-right: auto;
    "
  ></div>
</section>
<div class="container-fluid">
  <div class="row">
    <div
      class="col-sm-3 col-3"
      style="background-color: rgb(242, 242, 247) !important; margin-top: 0;"
    >
      <a class="nav-link" style="margin-top:25px">
        <h5>Bantuan</h5>
      </a>
      <div
        class="nav flex-column nav-pills"
        id="v-pills-tab"
        role="tablist"
        aria-orientation="vertical"
      >
        <a
          class="nav-link active"
          id="v-work-hour-tab"
          data-toggle="pill"
          href="#v-work-hour"
          role="tab"
          aria-controls="v-work-hour"
          aria-selected="true"
          >Pendaftaran Akun</a
        >
        <a
          class="nav-link"
          id="v-pills-forget-pass-tab"
          data-toggle="pill"
          href="#v-pills-forget-pass"
          role="tab"
          aria-controls="v-pills-forget-pass"
          aria-selected="false"
          >Cara Membuat Pesanan</a
        >
        <a
          class="nav-link"
          id="v-pills-download-tab"
          data-toggle="pill"
          href="#v-pills-download"
          role="tab"
          aria-controls="v-pills-download"
          aria-selected="false"
          >Pengiriman</a
        >
        <a
          class="nav-link"
          id="v-pills-order-item-tab"
          data-toggle="pill"
          href="#v-pills-order-item"
          role="tab"
          aria-controls="v-pills-order-item"
          aria-selected="false"
          >Status Pesanan</a
        >
        <a
          class="nav-link"
          id="v-pills-invoice-tab"
          data-toggle="pill"
          href="#v-pills-invoice"
          role="tab"
          aria-controls="v-pills-invoice"
          aria-selected="false"
          >Invoice</a
        >
      </div>
    </div>
    <div class="col-sm-9 col-9" style="margin-top: 25px;">
      <div class="tab-content" id="v-pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="v-work-hour"
          role="tabpanel"
          aria-labelledby="v-work-hour-tab"
        >
          <h4>Pendaftaran Akun</h4>
          <p>
            Bagaimana cara mendaftar menjadi customer Sukanda Onelink for
            Business?
          </p>
          <table class="table">
            <tbody>
              <tr>
                <td>Langsung mendaftar melalui Link berikut ini :</td>
                <td>https://www.sukandaonelink.com</td>
              </tr>
              <tr>
                <td>
                  Bisa juga dengan mendaftarkan diri melalu sales Sukanda ikuti
                  step gambar dibawah ini :
                </td>
              </tr>
              <tr>
                <td>
                  <img
                    class="logo-img-x forminlinemargin"
                    src="assets/img/regisbySales.png"
                    style="width: 100%; height: 100%; margin-left: 25%;"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="tab-pane fade"
          id="v-pills-forget-pass"
          role="tabpanel"
          aria-labelledby="v-pills-forget-pass"
        >
          <h4>Cara Membuat Pesanan</h4>
          <p>
            Dalam aplikasi Sukanda Onelink ini user diharapkan menyelesaikan
            order pada satu katalog sebelum membuat order baru pada katalog yang
            lain. Untuk menambahkan produk ke keranjang Anda dan membuat
            pesanan, berikut langkah-langkahnya:
          </p>
          <table class="table">
            <tbody>
              <tr>
                <td>1.</td>
                <td>Pilih salah satu katalog</td>
              </tr>
              <div class="col-sm-8">
                <img
                  class="logo-img-x forminlinemargin"
                  src="assets/img/catalogue sol.png"
                  style="width: 200%; height: 100%;"
                />
              </div>
              <tr>
                <td>2.</td>
                <td>Melakukan pencarian barang dan tambahkan kuantiti</td>
              </tr>
              <div class="col-sm-8">
                <img
                  class="logo-img-x forminlinemargin"
                  src="assets/img/pencarian sol.png"
                  style="width: 200%; height: 100%;"
                />
              </div>
              <tr>
                <td>3.</td>
                <td>Klik tombol <b>Cart</b> untuk melakukan transaksi</td>
              </tr>
              <tr>
                <td>4.</td>
                <td>
                  Tambahkan keterangan di kolom <b>Delivery Notes</b> ataupun
                  <b>Product Request</b> untuk spesial request ke sales admin
                </td>
              </tr>
              <tr>
                <td>5.</td>
                <td>Klik <b>Submit</b></td>
              </tr>
              <div class="col-sm-8">
                <img
                  class="logo-img-x forminlinemargin"
                  src="assets/img/cart sol.png"
                  style="width: 200%; height: 100%;"
                />
              </div>
            </tbody>
          </table>
        </div>
        <div
          class="tab-pane fade"
          id="v-pills-download"
          role="tabpanel"
          aria-labelledby="v-pills-download-tab"
        >
          <h4>Pengiriman</h4>
          <p>
            Jasa Pengiriman
           <br/> 
                Dikirim langsung oleh sales dari PT Sukanda
           <br/>
          </p>
          <p>
           Fasilitas Pengiriman
           <br/>
           Pengiriman Project ke Banyak Alamat
           <br/>
           Pengiriman ke Seluruh Indonesia
            
          </p>
        </div>
        <div
          class="tab-pane fade"
          id="v-pills-invoice"
          role="tabpanel"
          aria-labelledby="v-pills-invoice"
        >
          <h4>Invoice</h4>
          <table class="table">
            <tbody>
              <tr>
                <td>
                  Invoice dapat diunduh oleh akun admin anda.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="tab-pane fade"
          id="v-pills-order-item"
          role="tabpanel"
          aria-labelledby="v-pills-order-item"
        >
          <h4>Status Pesanan</h4>
          <p>
            Untuk melihat sejauh mana proses pesanan yang telah dibuat, user
            bisa klik menu <b>My History</b> yang ada di pojok kanan atas.
            Berikut merupakan keterangan untuk status yang ada di riwayat
            pemesanan
          </p>
          <table class="table table-striped">
            <thead class="thead-dark">
              <tr>
                <th>Status</th>
                <th>Keterangan</th>
              </tr>
            </thead>
            <tbody>
              <div class="col-sm-8">
                <img
                  class="logo-img-x forminlinemargin"
                  src="assets/img/cek status order sol.png"
                  style="width: 200%; height: 100%;"
                />
              </div>
              <tr>
                <td>Draft</td>
                <td>Customer masih dalam proses untuk membuat pesanan</td>
              </tr>
              <tr>
                <td>Submitted</td>
                <td>
                  Pesanan telah disubmit / dikirim ke sales admin untuk
                  dilakukan proses verifikasi
                </td>
              </tr>
              <tr>
                <td>Response Required</td>
                <td>
                  Di dalam pesanan terdapat barang komoditi sehingga memerlukan
                  pengajuan harga ke sales admin
                </td>
              </tr>
              <tr>
                <td>Processed</td>
                <td>
                  Pesanan telah diverifikasi oleh sales admin dan sedang
                  diproses oleh penjual
                </td>
              </tr>
              <tr>
                <td>Canceled</td>
                <td>Pesanan dibatalkan</td>
              </tr>
              <tr>
                <td>Delivered</td>
                <td>Pesanan sedang diperjalanan untuk proses pengiriman</td>
              </tr>
              <tr>
                <td>Received</td>
                <td>Pesanan telah diterima oleh customer</td>
              </tr>
            </tbody>
          </table>
          <h4>Melacak Pesanan</h4>
          <p>
            Kustomer bisa melihat sampai di mana proses atas pesanan yang telah
            mereka buat
          </p>
          <p>Cara melihat proses pesanan:</p>
          <table class="table">
            <tbody>
              <tr>
                <td>1.</td>
                <td>Masuk ke menu <b>My History</b></td>
              </tr>
              <tr>
                <td>2.</td>
                <td>
                  Pilih salah satu riwayat pesanan dengan klik id nya, maka user
                  akan melihat detail pesanan
                </td>
              </tr>
              <tr>
                <td>3.</td>
                <td>
                  Klik lagi tombol tiga garis yang ada di kanan atas menu, dan
                  kemudian pilih <b>Deliveries Info</b>
                </td>
              </tr>
              <tr>
                <td>4.</td>
                <td>User akan melihat status pesanan yang telah dibuat</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
